import React, { useEffect } from "react";
import * as style from "./Project.module.scss";
import { Button, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

import { ChevronLeft } from "react-bootstrap-icons";
import images from "url:../../assets/img/projects/**/*";

const Project = () => {
  const { projectId } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={style.root}>
      <Container className="px-0" fluid>
        <div className="d-flex align-center">
          <span className="d-block pt-4">
            <Link to={`/`} className={`text-decoration-none`}>
              <ChevronLeft size={32} color={`black`} />{" "}
              <span className="text-dark">Go Back</span>
            </Link>
          </span>
          <div className="d-flex align-items-center header4 mx-4">
            <span>{projectId}</span>
          </div>
        </div>

        {Object.values(images[projectId]).flatMap((entry, index) => (
          <Row key={`image-${index}`}>
            <img src={entry} className={style.image} />
          </Row>
        ))}
      </Container>
    </div>
  );
};

export default Project;
